import * as ActionTypes from "./ActionTypes";

const initialState = {
  isLoading: true,
  success: false,
  error: false,
};

const PlansReducer = function (state = initialState, action) {
  switch (action.type) {
    case ActionTypes.PLANS_GET_REQUEST:
      return {
        ...state,
        isLoading: true,
        success: false,
        error: false,
      };
    case ActionTypes.PLANS_GET_SUCCESS:
      return {
        ...state,
        Loading: false,
        success: true,
        error: false,
        plansdata: action.payload?.data?.data,
      };
    case ActionTypes.PLANS_GET_ERROR:
      return {
        ...state,
        Loading: false,
        success: false,
        error: true,
      };
    default:
      return state;
  }
};

export default PlansReducer;
